import { AutogenModelLoadboards, AutogenRowLoadboards } from "./autogen/AutogenModelLoadboards";

export class ModelLoadboards extends AutogenModelLoadboards<RowLoadboards> {
    constructor() {
        super(RowLoadboards);
    }
}

export class RowLoadboards extends AutogenRowLoadboards {
}